// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  OfferingPackageCardOfferingPackageFragmentDoc,
  OfferingPackageCardCoachFragmentDoc,
} from '../../package/__generated-gql-types__/OfferingPackageCard.generated';
import { OtherCategoriesTextCoachFragmentDoc } from './OtherCategoriesText.generated';
import { MessageModalCoachFragmentDoc } from '../modals/MessageModal/__generated-gql-types__/index.generated';
import { BookHourlyCoachingModalCoachFragmentDoc } from '../modals/__generated-gql-types__/BookHourlyCoachingModal.generated';
import { ServicesDescriptionCoachingFocusFragmentDoc } from './ServicesDescription.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CoachOfferingsOfferingPackageFragment = {
  __typename?: 'OfferingPackage';
  id: string;
  slug?: string | null;
  name: string;
  subTitle?: string | null;
  isUniversalPackage: boolean;
  imageLink?: string | null;
  prices?: Array<{
    __typename?: 'OfferingPackagePrice';
    sku?: string | null;
    price: number;
    packageCoachingTime?: {
      __typename?: 'PackageCoachingTime';
      exactTimeInMinute?: number | null;
      estimate?: {
        __typename?: 'IntRange';
        start?: number | null;
        end?: number | null;
      } | null;
    } | null;
  }> | null;
  category?: { __typename?: 'Category'; id: string; slug: string } | null;
  coach: { __typename?: 'Coach'; id: string; slug: string };
};

export type CoachOfferingsCoachFragment = {
  __typename?: 'Coach';
  id: string;
  slug: string;
  newExperience?: boolean | null;
  lelandPlusContributor: boolean;
  hourlyRate?: number | null;
  visibility: Types.CoachVisibility;
  tier: Types.SkuTier;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    newExperience: boolean;
  } | null;
  categoryInformationList?: Array<{
    __typename?: 'CategoryInformation';
    category: {
      __typename?: 'Category';
      id: string;
      slug: string;
      name: string;
    };
    coachingFocusList?: Array<{
      __typename?: 'CoachingFocus';
      id: string;
      name: string;
      slug: string;
    }> | null;
  }> | null;
  availability?: {
    __typename?: 'CoachAvailability';
    defaultAvailability?: {
      __typename?: 'DefaultAvailability';
      totalInMinute: number;
    } | null;
  } | null;
  mostRecentOrder?: {
    __typename?: 'Order';
    hourlyOrder?: { __typename?: 'HourlyOrder'; timeInMinute: number } | null;
  } | null;
};

export type CoachOfferingsCoachingFocusFragment = {
  __typename?: 'CoachingFocus';
  id: string;
  name: string;
};

export type CoachOfferingsUserQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CoachOfferingsUserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    applicant?: {
      __typename?: 'Applicant';
      lelandPlus?: { __typename?: 'LelandPlus'; active: boolean } | null;
    } | null;
  } | null;
};

export type CoachOfferingsSkusQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CoachOfferingsSkusQuery = {
  __typename?: 'Query';
  skus: {
    __typename?: 'SkuBatchResponse';
    results: Array<{
      __typename?: 'Sku';
      id: string;
      tier: Types.SkuTier;
      unitPrice: number;
    }>;
  };
};

export const CoachOfferingsOfferingPackageFragmentDoc = gql`
  fragment CoachOfferings_OfferingPackage on OfferingPackage {
    ...OfferingPackageCard_OfferingPackage
  }
  ${OfferingPackageCardOfferingPackageFragmentDoc}
`;
export const CoachOfferingsCoachFragmentDoc = gql`
  fragment CoachOfferings_Coach on Coach {
    id
    slug
    newExperience
    user {
      id
      firstName
    }
    lelandPlusContributor
    hourlyRate
    visibility
    coachingRelationship {
      id
      newExperience
    }
    ...OtherCategoriesText_Coach
    ...MessageModal_Coach
    ...BookHourlyCoachingModal_Coach
    ...OfferingPackageCard_Coach
  }
  ${OtherCategoriesTextCoachFragmentDoc}
  ${MessageModalCoachFragmentDoc}
  ${BookHourlyCoachingModalCoachFragmentDoc}
  ${OfferingPackageCardCoachFragmentDoc}
`;
export const CoachOfferingsCoachingFocusFragmentDoc = gql`
  fragment CoachOfferings_CoachingFocus on CoachingFocus {
    ...ServicesDescription_CoachingFocus
  }
  ${ServicesDescriptionCoachingFocusFragmentDoc}
`;
export const CoachOfferingsUserDocument = gql`
  query CoachOfferings_User {
    user {
      id
      applicant {
        lelandPlus {
          active
        }
      }
    }
  }
`;

/**
 * __useCoachOfferingsUserQuery__
 *
 * To run a query within a React component, call `useCoachOfferingsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachOfferingsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachOfferingsUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoachOfferingsUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CoachOfferingsUserQuery,
    CoachOfferingsUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CoachOfferingsUserQuery,
    CoachOfferingsUserQueryVariables
  >(CoachOfferingsUserDocument, options);
}
export function useCoachOfferingsUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachOfferingsUserQuery,
    CoachOfferingsUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CoachOfferingsUserQuery,
    CoachOfferingsUserQueryVariables
  >(CoachOfferingsUserDocument, options);
}
export function useCoachOfferingsUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CoachOfferingsUserQuery,
    CoachOfferingsUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoachOfferingsUserQuery,
    CoachOfferingsUserQueryVariables
  >(CoachOfferingsUserDocument, options);
}
export type CoachOfferingsUserQueryHookResult = ReturnType<
  typeof useCoachOfferingsUserQuery
>;
export type CoachOfferingsUserLazyQueryHookResult = ReturnType<
  typeof useCoachOfferingsUserLazyQuery
>;
export type CoachOfferingsUserSuspenseQueryHookResult = ReturnType<
  typeof useCoachOfferingsUserSuspenseQuery
>;
export type CoachOfferingsUserQueryResult = Apollo.QueryResult<
  CoachOfferingsUserQuery,
  CoachOfferingsUserQueryVariables
>;
export const CoachOfferingsSkusDocument = gql`
  query CoachOfferings_Skus {
    skus(numberOfSessions: 8, period: MONTHLY) {
      results {
        id
        tier
        unitPrice
      }
    }
  }
`;

/**
 * __useCoachOfferingsSkusQuery__
 *
 * To run a query within a React component, call `useCoachOfferingsSkusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachOfferingsSkusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachOfferingsSkusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoachOfferingsSkusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CoachOfferingsSkusQuery,
    CoachOfferingsSkusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CoachOfferingsSkusQuery,
    CoachOfferingsSkusQueryVariables
  >(CoachOfferingsSkusDocument, options);
}
export function useCoachOfferingsSkusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachOfferingsSkusQuery,
    CoachOfferingsSkusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CoachOfferingsSkusQuery,
    CoachOfferingsSkusQueryVariables
  >(CoachOfferingsSkusDocument, options);
}
export function useCoachOfferingsSkusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CoachOfferingsSkusQuery,
    CoachOfferingsSkusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoachOfferingsSkusQuery,
    CoachOfferingsSkusQueryVariables
  >(CoachOfferingsSkusDocument, options);
}
export type CoachOfferingsSkusQueryHookResult = ReturnType<
  typeof useCoachOfferingsSkusQuery
>;
export type CoachOfferingsSkusLazyQueryHookResult = ReturnType<
  typeof useCoachOfferingsSkusLazyQuery
>;
export type CoachOfferingsSkusSuspenseQueryHookResult = ReturnType<
  typeof useCoachOfferingsSkusSuspenseQuery
>;
export type CoachOfferingsSkusQueryResult = Apollo.QueryResult<
  CoachOfferingsSkusQuery,
  CoachOfferingsSkusQueryVariables
>;
